import { render } from "./ViewPrice.vue?vue&type=template&id=15536c9a&ts=true"
import script from "./ViewPrice.vue?vue&type=script&lang=ts"
export * from "./ViewPrice.vue?vue&type=script&lang=ts"

import "./ViewPrice.vue?vue&type=style&index=0&id=15536c9a&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/HeThongPVNB/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__